export const getHeading = (chatDate) => {
  const today = new Date();
  const chatDateObj = new Date(chatDate);

  // Clear the time part
  const todayStart = new Date(today.setHours(0, 0, 0, 0));
  const yesterdayStart = new Date(
    todayStart.getTime() - 1 * 24 * 60 * 60 * 1000
  );
  const last7DaysStart = new Date(
    todayStart.getTime() - 6 * 24 * 60 * 60 * 1000
  );
  const last30DaysStart = new Date(
    todayStart.getTime() - 29 * 24 * 60 * 60 * 1000
  );

  if (chatDateObj >= todayStart) {
    return 'Today';
  } else if (chatDateObj >= yesterdayStart) {
    return 'Yesterday';
  } else if (chatDateObj >= last7DaysStart) {
    return 'Previous 7 Days';
  } else if (chatDateObj >= last30DaysStart) {
    return 'Previous 30 Days';
  } else {
    return 'Older';
  }
};
